<div class="list-content">
  <div>
    <h3 class="listTitle">Work Objects</h3>
    <mat-list>
      @for (
        workobjectEntry of workobjectEntriesSubject | async;
        track workobjectEntry
      ) {
        <mat-list-item>
          <mat-form-field class="inputText dense-8" color="accent">
            <input
              matInput
              class="inputText"
              [value]="workobjectEntry.name"
              (change)="updateWorkobjectEntry($event, workobjectEntry)"
            />
          </mat-form-field>
        </mat-list-item>
      }
    </mat-list>
  </div>
  <div>
    <h3 class="listTitle">Activities</h3>
    <mat-list>
      @for (
        activityEntry of activityEntriesSubject | async;
        track activityEntry
      ) {
        <mat-list-item>
          <mat-form-field class="inputText dense-8" color="accent">
            <textarea
              matInput
              class="inputText activity"
              [value]="activityEntry.name"
              (change)="updateActivityEntry($event, activityEntry)"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="3"
              (keydown.enter)="preventDefault($event)"
              (keyup.enter)="save()"
              (keyup.escape)="close()"
            ></textarea>
          </mat-form-field>
        </mat-list-item>
      }
    </mat-list>
  </div>
</div>
<mat-dialog-actions class="sticky-bottom">
  <button mat-flat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
